export const moveInTrackEvent = ({ seekerId, roomId, role }) => {};

export const moveOutTrackEvent = ({ seekerId, roomId, role }) => {};

export const moveInOutCancelTrackEvent = ({ seekerId, role, roomId }) => {};

export const messageCancelTrackEvent = ({ seekerId, role, roomId }) => {};

export const messageContinueTrackEvent = ({ seekerId, role, roomId }) => {};

export const moveInOutContinueTrackEvent = ({ seekerId, role, roomId }) => {};

export const moveInOutNextStepTrackEvent = ({
  seekerId,
  skipMessageStep,
}) => {};

export const summaryTrackEvent = ({
  price,
  seekerId,
  roomId,
  role,
  reply,
}) => {};

export const showPaymentInformationPopupTrackEvent = () => {};

export const requestSentTrackEvent = () => {};

export const paymentTrackEvent = () => {};

export const paymentCancelTrackEvent = () => {};

export const moveToConversationTrackEvent = () => {};

export const requestAcceptTrackEvent = () => {};

export const requestDeclineTrackEvent = () => {};

export const requestDeclineConfirmTrackEvent = () => {};

export const modifyDatesTrackEvent = () => {};

export const requestShowTrackEvent = () => {};

export const showConfirmationPopupTrackEvent = () => {};

export const recoveryShownTrackEvent = () => {};

export const recoveryRetryClickedTrackEvent = () => {};

export const bookingGuaranteeBannerClicked = () => {};

export const annotationClicked = () => {};

export const bookingGuaranteePopupLinkClicked = () => {};

export const bookingCheckoutShownTrackEvent = () => {};

const bookingTrackingEvents = ({
  seekerId,
  roomId,
  price,
  role,
  reply = false,
  bookNow = false,
  userId,
  city,
  country,
}) => {
  return {
    bookingCheckoutShown: ({ bookingRequestId }) => {
      bookingCheckoutShownTrackEvent({ bookingRequestId, seekerId, roomId });
    },
    moveToConversation: () =>
      moveToConversationTrackEvent({ seekerId, roomId, role }),
    paymentCancel: () =>
      paymentCancelTrackEvent({ seekerId, roomId, role, reply }),
    payment: () => paymentTrackEvent({ seekerId, roomId, role, reply }),
    recoveryShown: () => recoveryShownTrackEvent({ seekerId, roomId }),
    recoveryRetryClicked: () =>
      recoveryRetryClickedTrackEvent({ roomId, seekerId }),
    requestAccept: () =>
      requestAcceptTrackEvent({
        price,
        seekerId,
        roomId,
        role,
      }),
    requestDecline: () =>
      requestDeclineTrackEvent({ roomId, seekerId, userId }),
    requestDeclineConfirm: () =>
      requestDeclineConfirmTrackEvent({ roomId, seekerId, userId }),
    requestSent: ({ id: bookingRequestId, totalPrice }) =>
      requestSentTrackEvent({
        bookingRequestId,
        price: totalPrice,
        seekerId,
        roomId,
        role,
        city,
        country,
      }),
    summary: ({ totalPrice }) =>
      summaryTrackEvent({
        seekerId,
        roomId,
        role,
        price: totalPrice,
        reply,
      }),
    modifyDatesClicked: () =>
      modifyDatesTrackEvent({
        seekerId,
        roomId,
        userId,
      }),
    moveInOutContinue: () =>
      moveInOutContinueTrackEvent({ seekerId, role, roomId }),
    moveInOutNextStep: (skipMessageStep) =>
      moveInOutNextStepTrackEvent({ seekerId, skipMessageStep }),
    moveInOutCancel: () =>
      moveInOutCancelTrackEvent({ seekerId, role, roomId }),
    messageCancel: () => messageCancelTrackEvent({ seekerId, role, roomId }),
    messageContinue: () =>
      messageContinueTrackEvent({ seekerId, role, roomId }),
    moveIn: () => moveInTrackEvent({ seekerId, roomId, role }),
    moveOut: () => moveOutTrackEvent({ seekerId, roomId, role }),
    requestShow: ({ screen } = {}) =>
      requestShowTrackEvent({
        seekerId,
        roomId,
        role,
        reply,
        bookNow,
        screen,
        city,
        country,
      }),
    showConfirmationPopup: () => showConfirmationPopupTrackEvent(),
    bookingGuaranteeBannerClicked: () =>
      bookingGuaranteeBannerClicked({ role }),
    showPaymentInformationPopup: () =>
      showPaymentInformationPopupTrackEvent({ seekerId, userId, roomId }),
    annotationClicked: () => annotationClicked({ role }),
    bookingGuaranteePopupLinkClicked: () =>
      bookingGuaranteePopupLinkClicked({ role }),
  };
};

export default bookingTrackingEvents;
